import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { useTheme } from './ThemeProvider';
import ThemeSelector from './ThemeSelector';

/**
 * Footer theme control: "Theme: {mode}" with the mode as a link that opens layout/mode options.
 */
const ThemeSelectorFooter = () => {
  const {
    mode
  } = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: "theme-selector-footer"
  }, "Theme:", ' ', /*#__PURE__*/React.createElement(UncontrolledDropdown, {
    direction: "up",
    className: "theme-selector-footer__dropdown"
  }, /*#__PURE__*/React.createElement(DropdownToggle, {
    tag: "button",
    type: "button",
    className: "theme-selector-footer__toggle",
    "aria-label": "Change theme"
  }, mode), /*#__PURE__*/React.createElement(DropdownMenu, {
    right: true,
    className: "theme-selector-footer__menu"
  }, /*#__PURE__*/React.createElement(ThemeSelector, null))));
};
export default ThemeSelectorFooter;